/* Copyright (c) 2018 Scaper */

import { APP_PATH } from "../appPath";

export const ADD_PAYMENT_METHOD_PATH = `${APP_PATH}/add-payment-method`;
